<div [hidden]="invoiceItems.length === 0">
  <table class="cpo-selectable-table">
    <thead>
      <tr class="cpo-selectable-table__header-row">
        <th (click)="handleSortByChange('name')">Name {{ this.sortBy === 'name' ? (this.sortDirection === 'asc' ? '↑' : '↓') : '' }}</th>
        <th class="no-sort">Description</th>
        <th (click)="handleSortByChange('quantity')">Quantity {{ this.sortBy === 'quantity' ? (this.sortDirection === 'asc' ? '↑' : '↓') : '' }}</th>
        <th (click)="handleSortByChange('unitPrice')">Unit Price {{ this.sortBy === 'unitPrice' ? (this.sortDirection === 'asc' ? '↑' : '↓') : '' }}</th>
        <th class="no-sort" [hidden]="readonly"></th>
      </tr>
    </thead>
    <tbody>
      @for (
        item of invoiceItems; 
        track item;      
        let even = $even;
        let odd = $odd
      ) {
        <tr 
          id="trsummary_{{ item.id }}"
          [ngClass]="{ even: even, odd: odd }"
          class="cpo-selectable-table__row"
        >
          <td>{{ item.name }}</td>
          <td>{{ item.description }}</td>
          <td class="cpo-table-cell-input">
            <app-textbox
              [type]="TextModes.Numeric"
              [ngModel]="item.quantity"
              (onChanged)="handleQuantityChange(item, $event)"
              [style]="'width: 100px;'"
              [readonly]="readonly"
            ></app-textbox>
          </td>
          <td class="cpo-table-cell-input">
            <app-textbox
              [type]="TextModes.CurrencyUSD"
              [ngModel]="item.unitPrice"
              (onChanged)="handleAmountChange(item, $event)"
              [style]="'width: 100px;'"
              [readonly]="readonly"
            ></app-textbox>
          </td>
          <td [hidden]="readonly">
            <app-icon type="Trash" [color]="'var(--archive-red)'" [style]="'cursor: pointer;'" (click)="handleRemoveItem(item)"></app-icon>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<div style="display: flex; gap: 10px; margin-top: 20px; flex-direction: column;" [hidden]="readonly">
  <app-selectbox
    [options]="catalogItemsOptions"
    [searchable]="true"
    (searchChange)="handleSearchChange($event)"
    (onChanged)="handleSelectedSearchRecord($event)"
    [ngModel]="selectedItemId"
    [label]="'Select item'"
  ></app-selectbox>
  <div (click)="handleAddNewItem()">
    <span style="font-size:.9em; font-weight:500; cursor: pointer; color:var(--green-700); text-decoration: underline;">+ Add New Item</span>
  </div>
</div>
